import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectFeatureFlag } from 'lib-bw-svc-apis/src/lib/featureFlags/feature-flags.selectors';
import { HttpService } from '../http/http.service';
import { environment } from 'environments/environment';
import { apiConstant } from '../constant/apiConstant';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagsService {
  constructor(
    private store: Store,
    private httpService: HttpService
  ) {}
  private agendaReplacement: boolean = false;
  private agendaCustomColors: boolean = false;
  private multiplePresenters: boolean = false;
  private partialSave: boolean = false;
  private userDeletion: boolean = false;
  private idleTimeOut: boolean = false;
  private browserRestriction: boolean = false;
  private aiCustomQuery: boolean = false;

  loadIdleTimeOutFlag(): Promise<boolean> {
    return new Promise(resolve => {
      this.httpService.get(`${environment.baseUrl}${apiConstant.systemFeature}`).subscribe((response: any) => {
        const value = !!response?.result?.idleTimeOut;
        localStorage.setItem('idleTimeOut', JSON.stringify(value));
        this.idleTimeOut = value;
        resolve(value);
      });
    });
  }

  isEnabled_AgendaReplacement(): boolean {
    this.store.select(selectFeatureFlag('agendaReplacement')).subscribe(event => (this.agendaReplacement = event));
    return this.agendaReplacement;
  }

  isEnabled_AgendaCustomColors(): boolean {
    this.store.select(selectFeatureFlag('agendaCustomColors')).subscribe(event => (this.agendaCustomColors = event));
    return this.agendaCustomColors;
  }

  isEnabled_MultiplePresenters(): boolean {
    this.store.select(selectFeatureFlag('multiplePresenters')).subscribe(event => (this.multiplePresenters = event));
    return this.multiplePresenters;
  }

  isEnabled_PartialSave(): boolean {
    this.store.select(selectFeatureFlag('partialSave')).subscribe(event => (this.partialSave = event));
    return this.partialSave;
  }

  isEnabled_UserDeletion(): boolean {
    this.store.select(selectFeatureFlag('userDeletion')).subscribe(event => (this.userDeletion = event));
    return this.userDeletion;
  }

  isEnabled_ResendOtp(): boolean {
    let resendOtp: boolean = false;
    this.store.select(selectFeatureFlag('resendOtp')).subscribe(event => (resendOtp = event));
    return resendOtp;
  }

  isEnabled_OfficerGroupDeletion(): boolean {
    let officerGroupDeletion: boolean = false;
    this.store.select(selectFeatureFlag('officerGroupDeletion')).subscribe(event => (officerGroupDeletion = event));
    return officerGroupDeletion;
  }

  isEnabled_MeetingDocPermReport(): boolean {
    let meetingDocPermReport: boolean = false;
    this.store.select(selectFeatureFlag('meetingDocPermReport')).subscribe(event => (meetingDocPermReport = event));
    return meetingDocPermReport;
  }

  isEnabled_BrowserRestriction(): boolean {
    let browserRestriction: boolean = false;
    this.store.select(selectFeatureFlag('browserRestriction')).subscribe(event => (browserRestriction = event));
    return browserRestriction;
  }

  isEnabled_IdleTimeOut(): boolean {
    const cached = localStorage.getItem('idleTimeOut');

    if (cached !== null) {
      return JSON.parse(cached);
    }

    this.httpService.get(`${environment.baseUrl}${apiConstant.systemFeature}`).subscribe((response: any) => {
      if (response.result) {
        localStorage.setItem('idleTimeOut', JSON.stringify(response?.result?.idleTimeOut));
        this.idleTimeOut = response?.result?.idleTimeOut;
      }
    });

    return this.idleTimeOut;
  }

  isEnabled_InviteExtUsers(): boolean {
    let inviteExterUsers: boolean = false;
    this.store.select(selectFeatureFlag('inviteExternalUsers')).subscribe(event => (inviteExterUsers = event));
    return inviteExterUsers;
  }

  isEnabled_AiCustomQuery(): boolean {
    let aiCustomQuery: boolean = false;
    this.store.select(selectFeatureFlag('aiCustomQuery')).subscribe(event => (aiCustomQuery = event));
    return aiCustomQuery;
  }
}

